import { useState, useRef, useEffect } from 'react';
import my_axios, { get_axios_data } from "@/pcomponents/common/axios";
import strFunc from '@/lib/lyg/string';
import { useSelector, useDispatch } from 'react-redux';
import Style from "./css/style.module.css";
import MessageListArea from "./area/msg_list";

function SendOrderMessageArea(props: any) {
  let myProps = {
    closePopup: () => { },
    refreshData: (inData: any) => { },
    callbackData: (inData: any) => { },
    order_seq_arr: [],
    msg_sort: "order_start_deliver",//order_start_deliver, order_notice
    ...props
  };
  let user = useSelector((state: any) => state.user);
  const [order_info_arr, set_order_info_arr] = useState<any[]>([]);
  const [katalk_template_info, set_katalk_template_info] = useState<any>({});
  const default_msg_json = {
    comp_name: "",
    receiver_name: "",
    content: "",
    deliver_comp: "",
    deliver_invoice: "",
    hello_msg: "",
    state_str: "",
  };

  useEffect(() => {
    get_order_info_arr_by_ajax({});
    get_katalk_template_info_by_ajax({});
  }, [myProps.order_seq_arr]);

  const get_order_info_arr_by_ajax = (inData: any) => {
    let opt_obj = {
      order_seq_arr: myProps.order_seq_arr,
      ...inData
    };
    let form_json_data: any = {
      s_mcomp_seq: "",
      s_pri_arr: opt_obj.order_seq_arr,
      s_addon_mcomp: "1",
      s_addon_detail: "1",
      s_addon_mcomp_addon: "1",
      s_addon_mcomp_corp: "1",
      is_paging: "",
    };
    my_axios.post(process.env.REACT_APP_API_URL + '/api/main/shop/shop_order/list',
      form_json_data, get_axios_data())
      .then((response) => {
        if (response.data["result"] === "true") {
          if (response.data["data"]["info_arr"].length != 0) {
            let tmp_info_arr = response.data["data"]["info_arr"];

            for (let i = 0; i < tmp_info_arr.length; i++) {
              let tmp_info = tmp_info_arr[i];
              tmp_info_arr[i]["send_msg_json"] = { ...default_msg_json };
              tmp_info_arr[i]["send_msg_json"]["comp_name"] = user.corp_name;
              tmp_info_arr[i]["send_msg_json"]["receiver_name"] = tmp_info["mcomp_name"];
              tmp_info_arr[i]["send_msg_json"]["content"] = tmp_info["a_title"];
              tmp_info_arr[i]["send_msg_json"]["deliver_comp"] = tmp_info["a_deliver_company"];
              tmp_info_arr[i]["send_msg_json"]["deliver_invoice"] = tmp_info["a_deliver_invoice"];
              tmp_info_arr[i]["send_msg_json"]["hello_msg"] = "주문하신 배송이 진행중입니다.";
              tmp_info_arr[i]["send_msg_json"]["state_str"] = "";
              tmp_info_arr[i]["send_msg_json"]["phone_num"] = "";
              if (tmp_info.corp_info && tmp_info.corp_info.a_response_tel) {
                tmp_info_arr[i]["send_msg_json"]["phone_num"] = tmp_info.corp_info.a_response_tel;
              }
              if (tmp_info.mcomp_addon && tmp_info.mcomp_addon.a_responser_phone) {
                tmp_info_arr[i]["send_msg_json"]["phone_num"] = tmp_info.mcomp_addon.a_responser_phone;
              }
            }
            set_order_info_arr(tmp_info_arr);
          } else {
            alert("주문정보가 존재하지 않습니다.");
            myProps.closePopup();
          }
        } else {

        }
      });
  };

  const get_katalk_template_info_by_ajax = (inData: any) => {
    let opt_obj = {
      msg_sort: myProps.msg_sort,
      ...inData
    };

    if (strFunc.is_empty(user.comp_seq)) {
      alert("학원정보가 존재하지 않습니다.");
      myProps.closePopup();
      return;
    }

    let form_json_data: any = {
      s_sort: opt_obj.msg_sort,
      s_mcomp_seq: user.comp_seq,
      s_is_use: "1",
      is_paging: "",
    };
    my_axios.post(process.env.REACT_APP_API_URL + '/api/main/basic/mkatalk_templete/list',
      form_json_data, get_axios_data())
      .then((response) => {
        if (response.data["result"] === "true") {
          if (response.data["data"]["info_arr"].length > 0) {
            set_katalk_template_info(response.data["data"]["info_arr"][0]);
          }
        } else {

        }
      });
  };

  const send_message_by_ajax = (inData: any) => {
    let opt_obj = {
      ...inData
    };

    for (let i = 0; i < order_info_arr.length; i++) {
      let order_info = order_info_arr[i];
      if (order_info.send_msg_json) {
        if (strFunc.is_empty(order_info.send_msg_json.phone_num)) {
          alert("메시지 수신 전화번호 입력이 필요합니다.");
          return;
        }
        if (order_info.send_msg_json.phone_num.replace(/-/g, "").length < 10) {
          alert("메시지 수신 전화번호가 올바르지 않습니다.");
          return;
        }
      } else {
        alert("메시지 정보가 존재하지 않습니다.");
        return;
      }
    }

    let receive_arr: any = [];
    for (let i = 0; i < order_info_arr.length; i++) {
      let order_info = order_info_arr[i];
      if (order_info.send_msg_json) {
        receive_arr.push({
          ...order_info.send_msg_json,
          user_name: "관리자",
          user_seq: user.user_seq,
          phone_num: order_info.send_msg_json.phone_num
        });
      }
    }

    let form_json_data: any = {
      msg_row: {
        "a_owner_mcomp_seq": user.comp_seq,
        "a_sender_mcomp_seq": user.comp_seq,
        "a_sender_user_seq": user.user_seq,
        "a_sender": user.user_name,
        "a_title": "[알림] 주문 배송 안내",
        "a_content": "",
      },
      templete_sort: myProps.msg_sort,
      receive_arr: receive_arr,
    };

    my_axios.post(process.env.REACT_APP_API_URL + '/api/main/basic/katalk/send',
      form_json_data, get_axios_data())
      .then((response) => {
        if (response.data["result"] === "true") {
          alert("메시지가 성공적으로 발송되었습니다.");
          myProps.refreshData({});
          myProps.closePopup();
        } else {
          alert("메시지 발송에 실패하였습니다." + response.data["msg"]);
        }
      });
  };

  return (
    <div className={Style.wrap}>
      <MessageListArea
        Style={Style}
        katalk_template_info={katalk_template_info}
        order_info_arr={order_info_arr}
        set_order_info_arr={set_order_info_arr}
        msg_sort={myProps.msg_sort}
      ></MessageListArea>
      <div className={Style.btn_wrap}>
        <button className={Style.btn_send}
          onClick={() => {
            send_message_by_ajax({});
          }}
        >보내기</button>
        <button className={Style.btn_close}
          onClick={() => {
            myProps.closePopup();
          }}
        >닫기</button>
      </div>
    </div>
  );
};
export default SendOrderMessageArea;